import useLoader from '@hooks/useLoader';
import { myInfoSelector } from '@stores/myInfo';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { io, Socket } from 'socket.io-client';

export const SocketContext = React.createContext<Socket>({} as Socket);

export const SocketProvider = ({ children }: { children: React.ReactNode }) => {
  const { _id } = useSelector(myInfoSelector);
  const [socketIO, setSocketIO] = useState<Socket>();
  const { progressLoader, stopLoader } = useLoader();

  const createSocket = () => {
    return io(process.env.NEXT_PUBLIC_SERVER_URL + '/user', {
      transports: ['websocket'],
      query: {
        tenant: 'EGU',
        id: _id,
      },
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });
  };

  useEffect(() => {
    let heartbeatInterval: ReturnType<typeof setInterval>;
    if (!socketIO && _id) {
      const _socket = createSocket();
      setSocketIO(_socket);
      _socket.on('connect', () => {
        heartbeatInterval = setInterval(() => {
          _socket.emit('heartbeat', 'keep-alive');
        }, 10000);

        _socket.on('heartbeatResponse', () => {
          console.log('heart-beat');
        });
      });

      _socket.on('disconnect', () => {
        console.log('socket disconnected');
        setSocketIO(undefined);
        if (heartbeatInterval) {
          clearInterval(heartbeatInterval);
        }
      });
    }

    return () => {
      if (socketIO) {
        setSocketIO(undefined);
        socketIO.disconnect();
      }
      if (heartbeatInterval) {
        clearInterval(heartbeatInterval);
      }
    };
  }, [socketIO, _id]);

  useEffect(() => {
    if (socketIO) {
      stopLoader();
    } else {
      progressLoader();
    }
  }, [socketIO]);
  return (
    <>
      {socketIO && (
        <SocketContext.Provider value={socketIO}>
          {children}
        </SocketContext.Provider>
      )}
    </>
  );
};
